import React from 'react';
import './FeedbackPage.css';

function FeedbackPage() {

    const handleOpenForm = () => {
        window.open("https://forms.gle/Y6vGiU8qZxjZwJi97", "_blank");
    };

    return (
        <div className="profile-page-container" style={{ background: 'transparent', minHeight: 'auto', padding: '2rem 1rem' }}>
            <div className="profile-form-card">
                <h2>Feedback</h2>
                <p className="profile-subtitle">Do you want to give feedback about TaskSquare?</p>

                <div className="feedback-actions">
                    <button
                        onClick={handleOpenForm}
                        className="save-profile-button"
                        type="button"
                    >
                        Yes
                    </button>

                    <button
                        className="save-profile-button btn-secondary"
                        type="button"
                        onClick={() => { }} /* Doing nothing per requirements */
                    >
                        Maybe Later
                    </button>
                </div>
            </div>
        </div>
    );
}

export default FeedbackPage;
